import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { Provider } from "react-redux";
import store from "./redux/store.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";
import { LDWrapper } from "./utils/LDWrapper.jsx";
import SessionExpiredGate from "./components/SessionExpiredGate.jsx";
import { installExpiredSessionToastFilter } from "./utils/suppressExpiredSessionToasts.js";
//...
import * as Sentry from "@sentry/react";

const allowedSentryEnvs = ["staging", "production"];
const currentEnv = (process.env.ENVIRONMENT || "").toLowerCase();

if (allowedSentryEnvs.includes(currentEnv)) {
  Sentry.init({
    dsn: process.env.REACT_SENTRY_DSN,
    release: process.env.REACT_RELEASE,
    environment: process.env.ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

installExpiredSessionToastFilter();

ReactDOM.createRoot(document.getElementById("root")).render(
  <LDWrapper>
    <React.StrictMode>
      <Provider store={store}>
        <ToastContainer autoClose={5000} />
        <SessionExpiredGate>
          <App />
        </SessionExpiredGate>
      </Provider>
    </React.StrictMode>
  </LDWrapper>
);
